module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/13rnBoKxkIKSiQk6iSgEmM-77a6de913f2781b6aaacfe07d3b82f90.jpg";